import styles from './Kbd.module.css';

export interface KbdProps {
  children: string;
  /** `inverse` sits on a dark control. */
  tone?: 'default' | 'inverse';
  /** `sm` is the size in key hints at the edge of a screen; `md` sits on cards and buttons. */
  size?: 'sm' | 'md';
}

/** A key the person can press, drawn the way the Paper screens draw it. */
export function Kbd({ children, tone = 'default', size = 'md' }: KbdProps) {
  return <kbd className={[styles.kbd, styles[size], tone === 'inverse' ? styles.inverse : ''].filter(Boolean).join(' ')}>{children}</kbd>;
}
